import { render, staticRenderFns } from "./DemoToast.vue?vue&type=template&id=20262e0a&scoped=true&"
import script from "./DemoToast.vue?vue&type=script&lang=js&"
export * from "./DemoToast.vue?vue&type=script&lang=js&"
import style0 from "./DemoToast.vue?vue&type=style&index=0&id=20262e0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20262e0a",
  null
  
)

export default component.exports